import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Service from "../components/Service";
import Testimonial from "../components/Testimonial";
import Inquiry from "../components/Inquiry";
import Banner from "../components/Banner";
import HeroSection from "../components/HeroSection";
import VisualBreak from "../components/VisualBreak";
import EmpowerSection from "../components/EmpowerSection";
import Homecomp5 from "../components/Homecomp5";

const HomePage = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash === "#inquiry-form") {
      const formSection = document.getElementById("inquiry-form");
      if (formSection) {
        const yOffset = -80;
        const y = formSection.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    }
  }, [location]);

  return (
    <>
      <HeroSection />
      <Banner />
      <EmpowerSection />
      <VisualBreak />
      <Service />
      {/* <Homecomp5/> */}
      <Testimonial />
      <Inquiry />
    </>
  );
};

export default HomePage;

